import React from "react";
import { videoLayoutMode } from "../constants";
import ScreenFilm from "./ScreenFilm";

function PresentVerticalMode({ mode }) {
    const renderContent = () => {        
        if (mode === videoLayoutMode.screen) {
            return (
                <ScreenFilm />
            )
        } 
    } 

    return (
        <>
            { renderContent() }
        </>
    )
}

export default PresentVerticalMode;